<div class="flex flex-col">
  @if (emailSetWithPicker()) {
    <div class="-mt-4 mb-4 flex flex-row justify-center">
      <span class="font-heading">{{ form.controls.username.value }}</span>
    </div>
  }
  @if (referrerpage === 'password-reset') {
    <div class="mb-4 rounded-xl rounded-tl-none bg-informative-5 p-3 text-informative-150 xs:p-4">
      <div class="flex items-center gap-2 font-heading text-sm font-medium lg:text-base">
        <span class="flex h-6 w-6 items-center justify-center">
          <pay-icon [shape]="IconNames.Information" size="sm" />
        </span>
        <span class="leading-5">{{ 'login-page.login.forgot-password.referrer-text' | translate }}</span>
      </div>
    </div>
  }
  <form [formGroup]="form" (submit)="submit()" (keydown.enter)="submit()" class="flex w-full flex-col justify-start gap-6">
    @if (!emailSetWithPicker()) {
      <pay-login-last-used-emails [emails]="lastUsedEmails()" (emailClicked)="emailClickHandler($event)" (emailDeleteClicked)="handleEmailDelete($event)" />

      <pay-input
        [label]="'login-page.login.input.email.label' | translate"
        [name]="'username'"
        [formControl]="form.controls.username"
        [overrideValidation]="false"
        [autoComplete]="'username'" />
    }

    <pay-input
      [name]="'password'"
      [label]="'login-page.login.input.password.label' | translate"
      [formControl]="form.controls.password"
      type="password"
      [showPasswordSvg]="true" />
  </form>
  <div class="flex justify-between">
    <div class="mt-4 text-primary-100 underline hover:cursor-pointer hover:text-primary-130" (click)="goToResetPassword()">
      {{ 'login-page.login.forgot-password.label' | translate }}
    </div>
    @if (emailSetWithPicker()) {
      <div class="mt-4 text-primary-100 underline hover:cursor-pointer hover:text-primary-130" (click)="clearEmailSetWithPicker()">
        {{ 'Clear email' | translate }}
      </div>
    } @else {
      <div class="-mr-2 mt-4 flex flex-row gap-1 text-neutral-80">
        <span>{{ 'common.remember-me-email' | translate }}</span>
        <pay-checkbox type="button" [formControl]="rememberEmail" (keydown.enter)="$event.stopPropagation()" />
      </div>
    }
  </div>

  @if (error) {
    <pay-login-error-badge class="mt-6" [error]="error!" />
  }
  <div class="mt-8 flex flex-col gap-6">
    <pay-button-primary id="submit" (click)="submit()" [loading]="isSubmitting()" type="submit" [rounded]="'rounded-lg'">
      {{ 'login-page.login.button-login.label' | translate }}
    </pay-button-primary>

    <div class="flex justify-center gap-2 text-neutral-80">
      <span class="text-neutral-80">{{ 'login-page.login.register.text' | translate }}</span>
      <a (click)="redirectToSignup()" class="text-primary-100 underline hover:cursor-pointer hover:text-primary-130">
        {{ 'login-page.login.register.label' | translate }}
      </a>
    </div>
  </div>
</div>
